module.exports = __webpack_public_path__ + "static/media/mastercard.25a1f38b.png";